import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getClientList = createAsyncThunk("/get-contact-list", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}crm/api/v1/get-contact`, data, {
      headers: {
        "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("re response", response);
    return response; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products r:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});


export const getClientById = createAsyncThunk(
  "client/getClientById",
  async (clientId, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.get(
        `${baseUrl}crm/api/v1/get-contact-by-id/${clientId}`,
        {
          headers: {
            "auth-token": token,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("getClientById response:", response.data);

      // ✅ RETURN ONLY DATA
      return response.data;

    } catch (error) {
      console.error("Error fetching client by id:", error);
      return rejectWithValue(
        error.response?.data || { success: false }
      );
    }
  }
);
